export default "__VITE_ASSET__1db4adb3__"